import React from 'react';
import fastestlogo from "../assets/images/logo.png";
import { NavLink } from 'react-router-dom';

// Framer Motion for smooth animations
import { motion } from 'framer-motion';

export default function FooterSection() {
    return (
        <footer className='px-[8%] pt-[8%] md:pt-[3%] pb-[3%] border border-t-1'>
            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false }}
                transition={{ duration: 1.5, ease: "easeInOut" }}
            >
                <div className='grid md:grid-cols-3 gap-4 text-[#70798D] text-[.8rem]'>

                    <div className="md:text-left text-center">
                        <div>
                            <img src={fastestlogo} alt="fasteslogo" className='w-[120px] pb-2' />
                        </div>
                        <div>
                            <ul>
                                <li>
                                    <NavLink to="/" className="hover:text-[var(--primary-color)]">
                                        Subscribe to our Newsletter
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="md:text-left text-center">
                        <ul className="flex md:flex-row flex-col md:pr-10 md:items-center md:gap-[1vw] gap-4">
                            <li>
                                <NavLink to="/" className="hover:text-[var(--primary-color)]">
                                    Home
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/about" className="hover:text-[var(--primary-color)]">
                                    About Us
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/about" className="hover:text-[var(--primary-color)]">
                                    FAQ
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="" className="hover:text-[var(--primary-color)]">
                                    Help Center
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="" className="hover:text-[var(--primary-color)]">
                                    Security
                                </NavLink>
                            </li>
                        </ul>
                    </div>

                    <div className='md:text-left text-center'>
                        <p className='text-center mb-7'>
                            <i className="fab fa-facebook px-4 hover:text-[var(--primary-color)]"></i>
                            <i className="fab fa-twitter px-4 hover:text-[var(--primary-color)]"></i>
                            <i className="fab fa-instagram px-4 hover:text-[var(--primary-color)]"></i>
                            <i className="fab fa-linkedin px-4 hover:text-[var(--primary-color)]"></i>
                        </p>
                        <ul className='flex md:flex-row flex-col md:pr-10 md:items-center md:gap-[2vw] gap-4'>
                            <li>
                                <NavLink to="" className="hover:text-[var(--primary-color)]">
                                    Payment Policy
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/" className="hover:text-[var(--primary-color)]">
                                    Terms of Use
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="" className="hover:text-[var(--primary-color)]">
                                    Careers
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="" className="hover:text-[var(--primary-color)]">
                                    Blog
                                </NavLink>
                            </li>
                        </ul>

                        <div className='mt-7'>
                            <p>&copy; 2025 Fastest | All Rights Reserved</p>
                        </div>
                    </div>
                </div>
            </motion.div>
        </footer>
    )
}
